<template>
    <div ref="settingsTabItems">
        <div ref="trustedDevicesBlock" class="mb-3">
            <div class="">
                <div class="mb-3">

                </div>

                <div v-if="responseMessage">
                    <div class="alert alert-info alert-dismissible fade show" role="alert">
                        <span v-html="responseMessage"></span>
                        <button aria-label="Close" class="btn-close" data-bs-dismiss="alert" type="button"
                                @click="(event) => responseMessage = ''"></button>
                    </div>
                </div>

                <div v-if="allSessions.length > 0">
	                <div class="mb-2">
		                <div class="d-flex justify-content-between align-items-center mb-3">
			                <h4 class="mb-0">All Sessions</h4>
			                <button class="btn btn-danger rounded-pill" type="button" @click="revokeAllSession">Sign Out All Devices</button>
		                </div>
		                <small class="text-muted">This is a list of devices that have logged into your account. Revoke any access that you don't recognize.</small>


	                </div>

                    <div class="d-flex" v-for="session in allSessions">
                        <div class="border-top d-flex w-100" >
	                        <div class="me-2 mt-2 mb-3">
		                        <i v-if="session.browser && session.browser.toLowerCase() === 'chrome'" class="bi bi-browser-chrome"></i>
		                        <i v-else-if="session.browser && session.browser.toLowerCase() === 'edge'" class="bi bi-browser-edge"></i>
		                        <i v-else-if="session.browser && session.browser.toLowerCase() === 'firefox'" class="bi bi-browser-firefox"></i>
		                        <i v-else-if="session.browser && session.browser.toLowerCase() === 'safari'" class="bi bi-browser-safari"></i>
		                        <i v-else-if="session.browser" class="bi bi-gear-wide-connected"></i>
	                        </div>
                            <div class="d-flex flex-column  w-100">
                                <div class="d-flex align-items-center mt-2 mb-1">

	                                <div class="w-100">
	                                    <div><span class="fs-5 fw-medium">{{ session.browser }}</span> <span class="text-muted" v-if="session.browser_version">(ver. {{ session.browser_version }})</span></div>
		                                <div><span>{{ session.platform }} </span> <small class="text-muted" v-if="session.platform_version">(ver. {{ session.platform_version }})</small></div>
	                                </div>
	                                <div class="ms-2">
		                                <span v-if="session.is_desktop" ><i class="bi bi-laptop" v-tooltip="'Desktop/Laptop Device'"></i></span>
		                                <span v-if="session.is_mobile" ><i class="bi bi-phone" v-tooltip="'Mobile Device'"></i></span>
		                                <span v-if="session.is_robot" ><i class="bi bi-robot" v-tooltip="'Bot Detected'"></i></span>
	                                </div>
                                </div>
	                            <div class="d-flex mb-3">
		                            <span v-if="session.trusted_device_id" class="d-flex align-items-center badge badge-success p-1 me-2">
				                        <i class="me-2 bi bi-check-circle p-0 h-auto w-auto" style="font-size: 16px;"></i> <span>Trusted Device</span>
				                    </span>

		                            <span v-if="session.id === currentSession.id" class="d-flex align-items-center badge badge-info p-1 me-2">
				                         <span>Current Session</span>
				                    </span>
	                            </div>
                                <div>
                                    <span class="text-muted">IP Address:</span> <span class="fw-medium fs-6">{{ session.ip_address }}</span>
                                </div>
                                <div>
                                    <span class="text-muted">Location:</span> <span class="fw-medium fs-6">{{ session.location }}</span>
                                </div>
                                <div class="mt-3">
                                    <span class="text-muted">Last Activity:</span> <span class="fw-medium fs-6">{{ session.last_activity }}</span>
                                </div>
	                            <div class="my-3" v-if="currentSession.id !== session.id">
		                            <a class="text-danger" type="button" @click="revokeSingleSession(session.id)">Revoke Access</a>
	                            </div>
                            </div>

                        </div>

                    </div>
                </div>
                <div class="">

                </div>
            </div>

        </div>
    </div>

	<AuthenticatedActionModal :action="authAction" :consider-trusted-device="considerTrustedDevice" :can-switch-two-factor-method="switchTwoFactorMethods" :can-use-recovery-codes="useRecoveryCodes" :reload-user="reloadUser" :data="data" v-if="showActionModal && authAction" @close-modal="closeAuthActionModal"></AuthenticatedActionModal>

</template>

<script setup>
import {onMounted, ref, watch} from "vue";
import {useAuthStore} from "@/stores/auth-store.js";
import apiClient from "@/utils/axios.js";
import {useHttpErrorManager} from "@/composables/useHttpErrorManager.js";
import {useAppHelpers} from "@/composables/useAppHelpers.js";
import AuthenticatedActionModal from "@/components/GenericModalAndViews/AuthenticatedActionModal.vue";

const auth = useAuthStore();
const helper = useAppHelpers();
const settingsTabItems = ref(null);
const trustedDevicesBlock = ref(null);
const responseMessage = ref("");

const showActionModal = ref(false);
const considerTrustedDevice = ref(true);
const switchTwoFactorMethods = ref(false);
const useRecoveryCodes = ref(false);
const reloadUser = ref(true);
const authAction = ref('');
const data = ref(null);

const user = ref(auth.user);
watch(() => auth.user, (newVal) => {
	user.value = newVal;
});

const closeAuthActionModal = async () => {
	authAction.value = '';
	showActionModal.value = false;
	considerTrustedDevice.value = true;
	switchTwoFactorMethods.value = false;
	reloadUser.value = true;
	data.value = null;
	useRecoveryCodes.value = false;

	await getLoggedInDevices();
}

const revokeSingleSession = (id) => {
	authAction.value = 'revoke_single_session';
	considerTrustedDevice.value = true;
	switchTwoFactorMethods.value = false;
	useRecoveryCodes.value = false;
	data.value = {
		session_id: id
	};
	showActionModal.value = true;
}

const revokeAllSession = () => {
	authAction.value = 'revoke_all_sessions';
	considerTrustedDevice.value = true;
	switchTwoFactorMethods.value = false;
	useRecoveryCodes.value = false;
	showActionModal.value = true;
}

onMounted(async () => {
    await getLoggedInDevices();
});

const allSessions = ref([]);
const trustedDeviceSessions = ref([]);
const otherSessions = ref([]);
const currentSession = ref(null);
const getLoggedInDevices = async () => {
    helper.loaderOn(trustedDevicesBlock.value);
    try {
        let url = "/auth/user/trusted-devices";

        const response = await apiClient.get(url);
        if (response.status === 200) {
            allSessions.value = response.data.sessions;
            trustedDeviceSessions.value = allSessions.value.filter(session => session.trusted_device_id !== null);
            otherSessions.value = allSessions.value.filter(session => session.trusted_device_id === null);
			currentSession.value = allSessions.value.find(session => session.id === response.data.currentSessionId);
        }
        helper.loaderOff(trustedDevicesBlock.value);
    }
    catch (error) {
        await useHttpErrorManager().handleError(error, true);
        helper.loaderOff(trustedDevicesBlock.value);
    }
}

onMounted(() => {
    helper.loaderOn(settingsTabItems.value);
    setTimeout(() => {
        helper.loaderOff(settingsTabItems.value);
    }, 500);
});

</script>

<style lang="scss" scoped>

</style>
